import { getAdvertising, getRuzhuStatus } from '@/axios/navigation'

const navagation = {
  namespaced: true,
  state: {
    swiperData: {},
    param: {
      appid: 'wzwebapp',
      timestamp: parseInt(new Date().getTime() / 1000)
    },
    isEnter: true,
    searchData: []
  },
  mutations: {
    setSwiperData (state, payload) {
      state.swiperData = payload
    },
    setIsEnter (state, payload) {
      state.isEnter = payload
    },
    setSearchData (state, payload) {
      state.searchData = payload
    }
  },
  actions: {
    getAdvertisingList ({ commit }, params) {
      getAdvertising(params).then(res => {
        if (res.data.code === 200) {
          commit('setSwiperData', res.data.data)
        }
      })
    },
    getRuzhuStatus ({commit}, params) {
      getRuzhuStatus(params).then(res => {
        if (res.data.code === 200) {
          commit('setIsEnter', true)
        } else {
          commit('setIsEnter', false)
        }
      })
    }
  }
}

export default navagation



// WEBPACK FOOTER //
// ./src/store/modules/navagation.js